module.exports = __webpack_public_path__ + "img/Shaman-draenei-f-70.e6bd258d.gif";